<template>
    <form ref="oneoff_cancel" class="pop-up--form card card--lg" v-on:submit.prevent="submit">
        <div class="card__header">
            <p class="card__title">Cancel one-off order</p>
            <p class="card__subtitle">Are you sure you want to cancel this order ? If you have made a mistake, you can edit it.</p>
        </div>
        <div class="card__content">
            <div class="checkbox">
                <div class="checkbox__item checkbox__item--required">
                    <input type="checkbox" name="terms" class="checkbox__control required" id="terms" value="">
                    <label for="terms" class="checkbox__label">I confirm that I want to cancel this order</label>
                </div>
            </div>
        </div>
        <div class="card__actions">
            <button type="submit" class="button button--md button--error">Cancel</button>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {}
    },

    beforeMount() {
    },

    methods: {
        submit() {
            if (!$(this.$refs.oneoff_cancel).valid()) return false;

            // Cancel order
            axios.post(`/api/order/${this.$root.oneOffCancel.id}/status`, {
                customer_id: this.$root.user.id,
                token: this.$root.user.password,
                status: 'CANCELED'
            }).then(res => {
                if (res.success === false) {

                } else {
                    // Show alert
                    $('#terms').prop('checked', false);
                    this.$root.oneOffCancel = null;
                    this.$root.alert = {
                        type: "SUCCESS",
                        title: "Cancel order",
                        text: "Your one-off order has been cancelled",
                    };

                    // Update datas
                  this.$root.orders.oneOff = res.data.datas.oneOff;
                    this.$root.orders.gift = res.data.datas.gift;
                    this.$root.orders.upcoming = res.data.datas.upcoming;
                }
            }).catch(error => console.log(error));
        }
    }
}
</script>
